import { Close } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { openNotification } from '../../../../helpers/notification';
import { generateFacilityInvoice } from '../../../../helpers/api';

export default function GenerateInvoice({ open, title, onClose, report }) {
  const [generating, setGenerating] = useState(false);

  const handleGenerateInvoice = async () => {
    setGenerating(true);
    try {
      const res = await generateFacilityInvoice(report?.reportId);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        openNotification({ type: 'success', message: status?.desc });
        onClose();
      } else {
        openNotification({ type: 'error', message: status?.desc });
      }
    } catch (err) {
      openNotification({
        type: 'error',
        message: 'Error trying to generate invoice. Please try again',
      });
    } finally {
      setGenerating(false);
    }
  };
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'center', paddingTop: '1rem' }}>
        <DialogTitle variant="body1" sx={{ fontWeight: 600 }}>
          {title}
        </DialogTitle>
        <Typography sx={{ marginLeft: 'auto', padding: '0 1rem' }}>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Typography>
      </Box>
      <DialogContent>
        <Alert severity="info">
          Generating {report?.reportTitle} for {report?.facility}
        </Alert>
        <br />
        <Typography variant="body2">
          {`If you proceed with this action the invoice for the facility will be generated. You can preview it at any time. You can also regenerate it so far payments has not been recorded for the invoice.`}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ padding: '1rem 1.5rem 2rem 1.5rem' }}>
        {/* <Button
          type="button"
          size="medium"
          variant="contained"
          color="error"
          sx={{ textTransform: 'none', borderRadius: '30px' }}
          //onClick={handlePreviewInvoie}
          startIcon={generating && <CircularProgress size={20} />}
          disabled={generating}
        >
          Generate and send
        </Button> */}
        <Button
          type="button"
          size="medium"
          variant="contained"
          sx={{ textTransform: 'none', borderRadius: '30px' }}
          onClick={handleGenerateInvoice}
          startIcon={generating && <CircularProgress size={20} />}
          disabled={generating}
        >
          Generate
        </Button>
      </DialogActions>
    </Dialog>
  );
}
